import { render } from "./TextInfo.vue?vue&type=template&id=89b2dd8a&scoped=true"
import script from "./TextInfo.vue?vue&type=script&lang=js"
export * from "./TextInfo.vue?vue&type=script&lang=js"

import "./TextInfo.vue?vue&type=style&index=0&id=89b2dd8a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b2dd8a"],['__file',"src/views/ServiceCenter/components/DetailInfoComponents/TextInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "89b2dd8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('89b2dd8a', __exports__)) {
    api.reload('89b2dd8a', __exports__)
  }
  
  module.hot.accept("./TextInfo.vue?vue&type=template&id=89b2dd8a&scoped=true", () => {
    api.rerender('89b2dd8a', render)
  })

}


export default __exports__